import HelperModal from "./HelperModal";
import HelperNoodremForm from "./HelperNoodremForm";

const HelperNoodrem = () => {
  return (
    <HelperModal bg="error" text="NOODREM" variants="exclamation">
      <HelperNoodremForm />
    </HelperModal>
  );
};

export default HelperNoodrem;
